import { create } from 'zustand';
import { AppPavilionData } from '../components/configurator/types';

export type PavilionsState = {
    pavilionDataLoading: boolean;
    pavilionDataError: string | null;
    pavilionData: {
        data: Record<string, AppPavilionData>;
    };
};

export const usePavilionsStore = create<{
    pavilions: PavilionsState;
    setPavilions: (data: any) => void;
    setLoading: (loading: boolean) => void;
    setError: (error: string | null) => void;
}>((set) => ({
    pavilions: {
        pavilionData: { data: {} },
        pavilionDataLoading: false, // Начальное состояние
        pavilionDataError: null, // Начальное состояние ошибки
    },
    setPavilions: (data) =>
        set((state) => ({
            pavilions: {
                ...state.pavilions,
                pavilionData: data, // Обновляем данные
                pavilionDataLoading: false, // Завершаем загрузку
                pavilionDataError: null, // Сбрасываем ошибку
            },
        })),
    setLoading: (loading) =>
        set((state) => ({
            pavilions: {
                ...state.pavilions,
                pavilionDataLoading: loading, // Обновляем флаг загрузки
                pavilionDataError: null, // Сбрасываем ошибку при начале загрузки
            },
        })),
    setError: (error) =>
        set((state) => ({
            pavilions: {
                ...state.pavilions,
                pavilionDataError: error,
                pavilionDataLoading: false,
            },
        })),
}));

export const usePavilionsValue = () => usePavilionsStore((state) => state.pavilions);

export const useSetPavilionsState = () => usePavilionsStore((state) => state.setPavilions);
export const useSetLoadingState = () => usePavilionsStore((state) => state.setLoading);
export const useSetErrorState = () => usePavilionsStore((state) => state.setError);
